"use strict";

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isOldChrome = exports.supportsWASMStreaming = exports.supportsSharedArrayBuffer = exports.supportsWASM = exports.supportsAudioWorklet = exports.supportsWorker = exports.supportsVoiceFocusWorker = exports.supportsWASMPostMessage = exports.isSafari = void 0;

var loader_js_1 = require("./loader.js");

var isChrome = function isChrome() {
  var global = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globalThis;
  var ua = global.navigator.userAgent;
  return !!ua.match(/Chrom(?:e|ium)\/([0-9]+)/);
};

var isSafari = function isSafari() {
  var global = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globalThis;
  var ua = global.navigator.userAgent;
  var hasSafari = ua.match(/Safari\//);
  var hasChrome = ua.match(/Chrom(?:e|ium)\//);
  return !!(hasSafari && !hasChrome);
};

exports.isSafari = isSafari;

var supportsWASMPostMessage = function supportsWASMPostMessage() {
  var global = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globalThis;

  if (exports.isSafari(global)) {
    return false;
  }

  if (isChrome(global)) {
    var version = chromeVersion(global) || 0;
    return version < 95;
  }

  return true;
};

exports.supportsWASMPostMessage = supportsWASMPostMessage;

var supportsVoiceFocusWorker = function supportsVoiceFocusWorker() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globalThis;
  var fetchConfig = arguments.length > 1 ? arguments[1] : undefined;
  var logger = arguments.length > 2 ? arguments[2] : undefined;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
    var workerURL, worker;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (exports.supportsWorker(scope, logger)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", false);

          case 2:
            workerURL = "".concat(fetchConfig.paths.workers, "worker-v1.js");
            _context.prev = 3;
            _context.next = 6;
            return loader_js_1.loadWorker(workerURL, 'VoiceFocusTestWorker', fetchConfig, logger);

          case 6:
            worker = _context.sent;

            try {
              worker.terminate();
            } catch (e) {
              logger === null || logger === void 0 ? void 0 : logger.debug('Failed to terminate worker.', e);
            }

            return _context.abrupt("return", true);

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](3);
            logger === null || logger === void 0 ? void 0 : logger.info('Failed to fetch and instantiate test worker', _context.t0);
            return _context.abrupt("return", false);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 11]]);
  }));
};

exports.supportsVoiceFocusWorker = supportsVoiceFocusWorker;

var supportsWorker = function supportsWorker() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globalThis;
  var logger = arguments.length > 1 ? arguments[1] : undefined;

  try {
    return !!scope.Worker;
  } catch (e) {
    logger === null || logger === void 0 ? void 0 : logger.info('Does not support Worker', e);
    return false;
  }
};

exports.supportsWorker = supportsWorker;

var supportsAudioWorklet = function supportsAudioWorklet() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globalThis;
  var logger = arguments.length > 1 ? arguments[1] : undefined;

  try {
    return !!scope.AudioWorklet && !!scope.AudioWorkletNode;
  } catch (e) {
    logger === null || logger === void 0 ? void 0 : logger.info('Does not support Audio Worklet', e);
    return false;
  }
};

exports.supportsAudioWorklet = supportsAudioWorklet;

var supportsWASM = function supportsWASM() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globalThis;
  var logger = arguments.length > 1 ? arguments[1] : undefined;

  try {
    return !!scope.WebAssembly && (!!scope.WebAssembly.compile || !!scope.WebAssembly.compileStreaming);
  } catch (e) {
    logger === null || logger === void 0 ? void 0 : logger.info('Does not support WASM', e);
    return false;
  }
};

exports.supportsWASM = supportsWASM;

var supportsSharedArrayBuffer = function supportsSharedArrayBuffer() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globalThis;
  var window = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : globalThis;
  var logger = arguments.length > 2 ? arguments[2] : undefined;

  try {
    return !!scope.SharedArrayBuffer && (!!window.chrome || !!scope.crossOriginIsolated);
  } catch (e) {
    logger === null || logger === void 0 ? void 0 : logger.info('Does not support SharedArrayBuffer.');
    return false;
  }
};

exports.supportsSharedArrayBuffer = supportsSharedArrayBuffer;

var supportsWASMStreaming = function supportsWASMStreaming() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globalThis;
  var logger = arguments.length > 1 ? arguments[1] : undefined;

  var _a;

  try {
    return !!((_a = scope.WebAssembly) === null || _a === void 0 ? void 0 : _a.compileStreaming);
  } catch (e) {
    logger === null || logger === void 0 ? void 0 : logger.info('Does not support WASM streaming compilation', e);
    return false;
  }
};

exports.supportsWASMStreaming = supportsWASMStreaming;
var SUPPORTED_CHROME_VERSION = 90;

var chromeVersion = function chromeVersion() {
  var global = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globalThis;

  try {
    if (!global.chrome) {
      return undefined;
    }
  } catch (e) {}

  var versionCheck = global.navigator.userAgent.match(/Chrom(?:e|ium)\/([0-9]+)/);

  if (!versionCheck) {
    return undefined;
  }

  return parseInt(versionCheck[1], 10);
};

var isOldChrome = function isOldChrome() {
  var global = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : globalThis;
  var logger = arguments.length > 1 ? arguments[1] : undefined;
  var version = chromeVersion(global);

  if (!version) {
    return false;
  }

  if (version < SUPPORTED_CHROME_VERSION) {
    logger === null || logger === void 0 ? void 0 : logger.debug("Chrome ".concat(version, " has incomplete SIMD support."));
    return true;
  }

  return false;
};

exports.isOldChrome = isOldChrome;